<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Регистрация</h1>
      <form @submit.prevent="submit">
        <div class="form-field">
          <label for="email">Email</label>
          <input id="email" v-model="email" type="email" autocomplete="email" required />
        </div>
        <div class="form-field">
          <label for="password">Пароль</label>
          <input id="password" v-model="password" type="password" autocomplete="new-password" required />
        </div>
        <div class="form-field">
          <label for="passwordConfirmation">Подтверждение пароля</label>
          <input
            id="passwordConfirmation"
            v-model="passwordConfirmation"
            type="password"
            autocomplete="new-password"
            required
          />
        </div>

        <details class="vehicle-details">
          <summary>Автомобиль (необязательно)</summary>
          <VehicleForm
            v-model:make="vehicleMake"
            v-model:equipment="vehicleEquipment"
            v-model:photos="vehiclePhotos"
            :disabled="loading"
          />
        </details>

        <p v-if="error" class="error-message">{{ error }}</p>
        <button class="btn" type="submit" :disabled="loading">
          {{ loading ? 'Создание...' : 'Создать аккаунт' }}
        </button>
      </form>
      <p style="margin-top: 1rem">
        Уже есть аккаунт?
        <router-link to="/login">Войти</router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import VehicleForm from '../components/VehicleForm.vue'
import { useAuthStore } from '../stores/auth'

const auth = useAuthStore()
const router = useRouter()

const email = ref('')
const password = ref('')
const passwordConfirmation = ref('')
const vehicleMake = ref('')
const vehicleEquipment = ref('')
const vehiclePhotos = ref([])
const loading = ref(false)
const error = ref('')

async function submit() {
  loading.value = true
  error.value = ''

  try {
    await auth.register(email.value, password.value, passwordConfirmation.value, {
      vehicle:
        vehicleMake.value.trim() ?
          {
            make: vehicleMake.value,
            equipment: vehicleEquipment.value,
          }
        : null,
      vehiclePhotos: vehiclePhotos.value,
    })
    router.push({ name: 'check-email', query: { email: email.value } })
  } catch (err) {
    const errors = err.response?.data?.errors
    error.value = Array.isArray(errors) ? errors.join(', ') : 'Не удалось зарегистрироваться'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.vehicle-details {
  margin: 1rem 0;
}

.vehicle-details summary {
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 0.75rem;
}
</style>
